
    PayTomorrow.mpeInit({
        debugMode: false,
        enableMoreInfoLink: true,
        logoColor: "original",
        maxAmount: 5000,
        maxTerm: 24,
        minAmount: 500,
        mpeSelector: ".mpe",
        priceSelector: ".mpe-price",
        storeDisplayName: "Xprousa",
        publicId: "ba8369157ddf3dcf95b94e14372fb860"
    })
